export default __webpack_public_path__ + "static/media/TikTok_Select_Fileformat.fd25ef8f.PNG";